import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-table-no-result',
  templateUrl: './table-no-result.component.html',
})
export class TableNoResultComponent {
  @Input() imageSrc: string;
  @Input() message: string;
  @Input() ctaText: string;
  @Input() ctaRouterLink: string[];
  @Output() ctaClick = new EventEmitter();
}
